import ProductImageList from './ProductImageList';

export default ProductImageList;
